// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import 'es6-promise/auto'
import promise from 'es6-promise' 


// import VueRouter from 'vue-router'
import axios from 'axios';

import ElementUI from 'element-ui';
import auth from "@/utils/auth";
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import "../static/css/override-element-ui.css"; //重写样式
import "../static/css/main.css";
import "../static/css/user_center.css";
import "../static/css/text.css";
import "../static/icon/iconfont.css";
import "../static/iconb/iconfont.css";
import "../static/fontb/iconfont.css";//阿里图标


Vue.config.productionTip = false

Vue.use(ElementUI, {
  size: 'small'
});
// Vue.use(VueRouter);
promise.polyfill();

//兼容 ie9
if (Number.parseInt === undefined) Number.parseInt = window.parseInt;
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;
//----------------添加拦截器-------------------------------------------
axios.create({
  headers: 'token'
});
Vue.prototype.isContainUndefined = function(url) {
    if (!url) {
      return false
    }
    return url.indexOf('undefined') == -1 // 如果包含就是true
  }

axios.interceptors.request.use(
  config => {
      let token = auth.getToken();
      if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
          config.headers['token'] = `${token}`;
      }
      return config;
  },
  err => {
      return Promise.reject(err);
  });
// 添加响应拦截器
axios.interceptors.response.use(function(response) {
  // // 对响应数据做点什么
  // //alert(JSON.stringify(response));
  if (response.data.code == 10000) {
      auth.removeToken();
      router.replace('/login');
      return Promise.reject(response.data);
  } else {
      return response;
  }


}, function(error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
axios.defaults.withCredentials = true; //意思是携带cookie信息,保持session的一致性
Vue.prototype.$axios = axios;

//使用钩子函数对路由进行权限跳转
router.afterEach((to, from) => {
  // debugger
  // let bodySrcollTop = document.body.scrollTop
  // if (bodySrcollTop !== 0) {
  //   document.body.scrollTop = 0
  //   return
  // }
  // let docSrcollTop = document.documentElement.scrollTop
  // if (docSrcollTop !== 0) {
  //   document.documentElement.scrollTop = 0
  // }

 
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js